var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { addToLoadingList, removeFromLoadingList, } from '@popup/multichain/actions/loading.actions';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { SavingsUtils } from '@popup/steem/utils/savings.utils';
import { KeychainKeyTypes } from '@steempro/steem-keychain-commons';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { CustomTooltip } from 'src/common-ui/custom-tooltip/custom-tooltip.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { Screen } from 'src/reference-data/screen.enum';
import FormatUtils from 'src/utils/format.utils';
const PendingSavingsWithdrawalItem = ({ item, currency, navigateToWithParams, navigateTo, setErrorMessage, setSuccessMessage, addToLoadingList, removeFromLoadingList, activeAccount, }) => {
    const cancelCurrentWithdrawSavingItem = () => {
        navigateToWithParams(Screen.CONFIRMATION_PAGE, {
            method: KeychainKeyTypes.active,
            message: getMessage('popup_html_confirm_cancel_withdraw_savings_message', [currency]),
            title: 'popup_html_cancel_withdraw_savings',
            fields: [
                {
                    label: 'popup_html_cancel_withdraw',
                    value: `${item.amount} ${moment(item.complete).format('L')}`,
                },
            ],
            afterConfirmAction: (options) => __awaiter(void 0, void 0, void 0, function* () {
                addToLoadingList('html_popup_cancel_withdraw_savings_operation');
                try {
                    let success = yield SavingsUtils.cancelCurrentWithdrawSaving(activeAccount.name, item.request_id, activeAccount.keys.active, options);
                    navigateTo(Screen.HOME_PAGE, true);
                    if (success) {
                        if (success.isUsingMultisig) {
                            setSuccessMessage('multisig_transaction_sent_to_signers');
                        }
                        else {
                            setSuccessMessage('popup_html_cancel_withdraw_savings_successful', [item.amount, currency]);
                        }
                    }
                    else {
                        setErrorMessage('popup_html_cancel_withdraw_savings_fail', [
                            currency,
                        ]);
                    }
                }
                catch (err) {
                    setErrorMessage(err.message);
                }
                finally {
                    removeFromLoadingList('html_popup_cancel_withdraw_savings_operation');
                }
            }),
        });
    };
    return (React.createElement("div", { className: "pending-savings-withdraw-row" },
        React.createElement(React.Fragment, null,
            React.createElement(CustomTooltip, { additionalClassName: "left-panel", skipTranslation: true, message: moment(item.complete).format('YYYY/MM/DD hh:mm:ss') },
                React.createElement("div", null, moment(item.complete).format('L'))),
            React.createElement("div", { className: "right-panel" },
                React.createElement("span", null, FormatUtils.formatCurrencyValue(parseFloat(item.amount.toString()))),
                React.createElement(SVGIcon, { className: "delete-icon", icon: SVGIcons.GLOBAL_DELETE, onClick: cancelCurrentWithdrawSavingItem })))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setErrorMessage,
    setSuccessMessage,
    addToLoadingList,
    removeFromLoadingList,
});
export const PendingSavingsWithdrawalItemComponent = connector(PendingSavingsWithdrawalItem);
